// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-avatar{position:relative}.user-avatar img{border-radius:50%;width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.user-avatar .border-container{height:100%}.user-avatar .border-container.gold>:not(.custom-spinner){border:2px solid var(--v-accentGold-base)}.user-avatar .person-icon{border-radius:50%;background:var(--v-primary-lighten1);padding:3px}", ""]);
// Exports
module.exports = exports;
